import { render } from "./ToolsScreen.vue?vue&type=template&id=0a15a278&scoped=true"
import script from "./ToolsScreen.vue?vue&type=script&lang=js"
export * from "./ToolsScreen.vue?vue&type=script&lang=js"

import "./ToolsScreen.vue?vue&type=style&index=0&id=0a15a278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a15a278"]])

export default __exports__